const computed = {
  getRows() {
    const rows = [];
    let index = 0;
    if (this.farmData[1]) {
      Object.values(this.farmData[1]).forEach((data) =>
        data.forEach((item) => {
          item.index = index;
          rows.push(item);
          index++;
        })
      );
    }
    return rows;
  },

  pagedData() {
    return this.getRows.slice(this.from, this.to);
  },

  pagedRows() {
    return this.getRows.slice(this.from, this.to);
  },

  queriedData() {
    let result = this.getRows;
    if (this.searchQuery !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '');
    }
    this.pagination.total = result.length;
    return result.slice(this.from, this.to);
  },

  total() {
    if (this.searchQuery === '') {
      this.pagination.total = this.getRows.length;
    }
    return this.pagination.total;
  },
};

export default { computed };
